/* WiseCar V4 menü: masaüstünde mega menü panelleri üzerine gelince açılır. */
(function () {
  var mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
  function init() {
    var items = document.querySelectorAll('.header__inline-menu .list-menu--inline > li');
    if (!items.length) return;
    function closeAll(except) {
      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) {
        if (d !== except) d.removeAttribute('open');
      });
    }
    items.forEach(function (li) {
      var d = li.querySelector('details'), t;
      li.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(t);
        closeAll(d);
        if (d && !d.hasAttribute('open')) d.setAttribute('open', '');
      });
      li.addEventListener('mouseleave', function () {
        if (!mq.matches || !d) return;
        t = setTimeout(function () { d.removeAttribute('open'); }, 180);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* WiseCar V4 mobil menü: başlıklar yerinde açılıp kapanır, aynı anda tek bölüm açık.
   Başlıklar <button> değil role="button": Dawn MenuDrawer çekmecedeki her butona "kapat" bağlıyor. */
(function () {
  function toggle(b) {
    var g = b.parentNode, open = !g.classList.contains('is-open');
    g.parentNode.querySelectorAll('.wc4m__grp.is-open').forEach(function (o) {
      if (o === g) return;
      o.classList.remove('is-open');
      o.querySelector('.wc4m__top').setAttribute('aria-expanded', 'false');
    });
    g.classList.toggle('is-open', open);
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.wc4m__grp > .wc4m__top');
    if (b) toggle(b);
  });
  document.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('.wc4m__grp > .wc4m__top');
    if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(b); }
  });
})();
